var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.96,
    height: 24.593,
    viewBox: "0 0 23.96 24.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(0 24.593) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1285",
    "data-name": "Group 1285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M17.449,0H7.144A7.062,7.062,0,0,0,0,6.96V17a7.062,7.062,0,0,0,7.144,6.96H17.449A7.062,7.062,0,0,0,24.593,17V6.96A7.062,7.062,0,0,0,17.449,0Zm5.223,17a5.163,5.163,0,0,1-5.223,5.088H7.144A5.163,5.163,0,0,1,1.921,17V6.96A5.163,5.163,0,0,1,7.144,1.872H17.449A5.163,5.163,0,0,1,22.672,6.96Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    "data-name": "Group 1287",
    transform: "translate(5.668 5.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1286",
    "data-name": "Group 1286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M6.629,0A6.552,6.552,0,0,0,0,6.458a6.552,6.552,0,0,0,6.629,6.458,6.552,6.552,0,0,0,6.629-6.458A6.552,6.552,0,0,0,6.629,0Zm0,11.044A4.653,4.653,0,0,1,1.921,6.458,4.653,4.653,0,0,1,6.629,1.872a4.653,4.653,0,0,1,4.707,4.586A4.653,4.653,0,0,1,6.629,11.044Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1289",
    "data-name": "Group 1289",
    transform: "translate(18.061 4.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1288",
    "data-name": "Group 1288"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 0.961,
    cy: 0.936,
    rx: 0.961,
    ry: 0.936,
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1b2b803313d03037c8af5bf9db79304d.svg";
export { ForwardRef as ReactComponent };